module.exports = __webpack_public_path__ + "static/typography-f79b0b53bd6220d2a0e29c4543eb4252.png";